/*
 * Purpose: Render middle panel for login/register forms in Access Shell layout.
 * Boundary: Always visible; renders login or register form via render props.
 * Invariants:
 * - Consumes { mode, renderLogin, renderRegister, showRightPanel } from props.
 * - ASCII only; no Unicode in comments or strings.
 */
import React from 'react';

// Component AccessShellMiddlePanelLayout:
export default function AccessShellMiddlePanelLayout({
    mode,
    renderLogin,
    renderRegister,
    showRightPanel
}) {
    return (
        <div
            className={`space-y-6 ${showRightPanel ? 'md:col-span-1' : 'md:col-span-1'}`}
            id={mode === 'login' ? 'panel-login' : 'panel-register'}
            role="tabpanel"
            aria-labelledby={mode === 'login' ? 'tab-login' : 'tab-register'}
        >
            {mode === 'login' ? renderLogin?.() : renderRegister?.()}
        </div>
    );
}